import { render, staticRenderFns } from "./HomeArticle.vue?vue&type=template&id=76fa1748&"
import script from "./HomeArticle.vue?vue&type=script&lang=js&"
export * from "./HomeArticle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports